import axiosFetchBase from '../axiosFetchBase';
import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';

export const externalUsersApi = createApi({
  reducerPath: 'externalUsersApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getExternalUsers: builder.query({
      query: () => ({
        url: urls.externalUsers,
      }),
    }),
    getExternalUserDetail: builder.query({
      query: (id) => ({
        url: urls.externalUserDetail(id),
      }),
    }),
    activateExternalUser: builder.mutation({
      query: (id) => ({
        url: urls.externalUserActivate(id),
        method: 'PUT',
      }),
    }),
    deactivateExternalUser: builder.mutation({
      query: (id) => ({
        url: urls.externalUserDeactivate(id),
        method: 'PUT',
      }),
    }),
    saveExternalUser: builder.mutation({
      query(req) {
        if (req.body.id) {
          return {
            url: urls.externalUserDetail(req.body.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: `${urls.externalUsers}`,
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
    deleteExternalUser: builder.mutation({
      query: (id) => ({
        url: urls.externalUserDelete(id),
        method: 'DELETE',
      }),
    }),
    deleteSelfExternalUser: builder.mutation({
      query: () => ({
        url: urls.externalUserDeleteSelf,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetExternalUsersQuery,
  useGetExternalUserDetailQuery,
  useActivateExternalUserMutation,
  useDeactivateExternalUserMutation,
  useSaveExternalUserMutation,
  useDeleteExternalUserMutation,
  useDeleteSelfExternalUserMutation,
} = externalUsersApi;
